import {
  Collapsible,
  CollapseActionContainer,
  CollapseAction,
  CollapseArrow,
  ActionTitle,
} from './CollapsibleContent.styles';
import { useGlobalState } from '@/hooks';
import { MasterTranslation } from '@/constants';

interface ICollasibleContentProps {
  isOpen?: boolean;
  handleToggle?: () => void;
  children: React.ReactNode;
}

const CollapsibleContent = ({ isOpen = true, handleToggle, children }: ICollasibleContentProps) => {
  const { t } = useGlobalState();
  const actionTitle = isOpen ? t(MasterTranslation.ViewLess) : t(MasterTranslation.ViewMore);

  return (
    <>
      {/* Collapsible Content */}
      <Collapsible isOpen={isOpen}>{children}</Collapsible>
      {/* Action */}
      <CollapseActionContainer>
        <CollapseAction onClick={handleToggle}>
          <ActionTitle>{actionTitle}</ActionTitle>
          <CollapseArrow isOpen={isOpen} />
        </CollapseAction>
      </CollapseActionContainer>
    </>
  );
};

export { CollapsibleContent };
